<template>
  <div>
    <b-nav class="primary-nav nav-fill">
      <b-nav-item> About
        <b-nav vertical class="secondary-nav">
          <b-nav-item :to="{ name: 'history' }">History</b-nav-item>
          <b-nav-item :to="{ name: 'aimsAndScope' }">Aims & Scope</b-nav-item>
          <b-nav-item :to="{ name: 'announcements' }">News</b-nav-item>
          <b-nav-item :to="{ name: 'sponsorshipRequest' }">Conference Sponsorship</b-nav-item>
        </b-nav>
      </b-nav-item>
      <b-nav-item :to="{ name: 'contact' }"></span>Contact <div class="icon icon-color-arrow-right-dark"></div></b-nav-item>
      <b-nav-item :to="{ name: 'careers' }"></span>Careers <div class="icon icon-color-arrow-right-dark"></div></b-nav-item>
    </b-nav>
  </div>
</template>
<script>

  export default {
    name: 'footer-navigation',
    data () {
      return {
      }
    }
  }
</script>
<style lang="scss">
  .primary-nav {
    & > .nav-item {
      padding: 10px 0 10px 0;
      a {
        padding: 0px;
        font-family: Merriweather;
        font-style: italic;
        text-decoration: underline;
        color: $primary-color;
        font-size: 15px;
        text-align: middle;
        border-left: 1px solid $navbar-item-separator;

        .icon {
          margin-left: 10px;
        }
      }
      &:first-child{
        a {
          text-decoration: none;
          border-left: none;
          text-align: start;
        }
      }
    }
    .secondary-nav {
      margin-top: 10px;
      .nav-item  {
        a {
          padding: 2px 0;
          font-family: 'Open Sans', sans-serif;
          font-size: 14px;
          text-decoration: underline;
          font-style: normal;
        }
      }
    }
  }
  @media (max-width: $breakpoint-md) {
    .primary-nav {
      flex-direction: column;
      padding: 0px;
      & > .nav-item {
            border-bottom: 1px solid $footer-background;
          }
      .nav-item {
        a {
          text-align: start;
          border-left-width: 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FooterNavigationComponent.vue?52bffbb1